module.exports = __webpack_public_path__ + "static/media/html.664a8c00.png";